export const environment = {
    name: 'test',
    version: 'web_21.2.0010',
    production: false,
    baseUrl: 'https://test.almaphil.net',
    repoUrl: 'https://repository.test.almaphil.net',
    serviceUrl: 'https://hd-service.test.almaphil.de',
    docUrl: 'https://almaphil.de/docs/',
    ssoUrl: 'https://sso.test.almaphil.de',
    sentry: {
        tracePropagationTargets: [
            'test.almaphil.de',
            'https://test.almaphil.net/api',
        ],
    },
    oidcLogLevel: 1,
    mapApiKey: '',
    sentryDSN: '',
};
